<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  images: { type: Array, required: true },
})
const selectedImage = ref(0)

const timeout = ref()

watch(selectedImage, () => {
  window.clearTimeout(timeout.value)
  timeout.value = window.setTimeout(() => {
    selectedImage.value = (selectedImage.value + 1) % props.images.length
  }, 5000)
}, { immediate: true })
</script>

<template>
  <div>
    <div class="aspect-video rounded-lg overflow-hidden w-full flex items-center justify-center">
      <img
        :src="images[selectedImage]"
        class="aspect-video object-cover w-full"
      >
    </div>
    <div
      v-if="images.length > 1"
      class="flex gap-1 overflow-x-auto mt-2"
    >
      <div
        v-for="img, i in images"
        :key="img"
        class="basis-1/5 min-w-0 flex flex-col items-center group pb-1 rounded-lg hover:bg-neutral-100 transition-all cursor-pointer"
        @click="selectedImage = i"
      >
        <img
          class="aspect-video object-cover rounded-lg"
          :src="img"
        >
        <div
          class="w-10 h-1 rounded-full mt-1 transition-all"
          :class="selectedImage === i ? 'bg-microsoft-blue-default' : 'group-hover:bg-neutral-400'"
        />
      </div>
    </div>
  </div>
</template>
